module.exports = __webpack_public_path__ + "img/Viviana.c786f997.jpg";